import { apiClient } from '~/lib/api/client';
import { ALL_REGION } from '~/pages/users/form/types';

export type KpiDateRangePreset = 'this_month' | 'last_3_months' | 'this_year' | 'last_year';

export interface KpiResponse {
  totalRegisteredNurseries: number;
  activePermits: number;
  newRegistration: number;
  renewalRegistration: number;
  pendingApplication: number;
  approvedApplication: number;
  rejectApplication: number;
  certificatesIssued: number;
  totalPlants: number;
  totalSaleablePlants: number;
  saleablePlantsPercentage: number;
  completedCn03: number;
  completedCn04: number;
  completedCn05: number;
  completedCn06: number;
}

export interface KpiQueryParams {
  dateRangePreset: KpiDateRangePreset;
  regionalCode: string;
}

/** Maps form "All" to API "all"; passes through regional office codes. */
export function toKpiRegionalCode(value: string | null | undefined): string {
  const trimmed = value?.trim();
  if (!trimmed || trimmed === ALL_REGION || trimmed.toLowerCase() === 'all') {
    return 'all';
  }
  return trimmed;
}

export async function getKpis(params: KpiQueryParams): Promise<KpiResponse> {
  const res = await apiClient.get<KpiResponse>('/analytics/kpis', { params });
  return res.data;
}
